import { Button } from '@cloudflare/kumo';
import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

/** Faixa fixa no topo enquanto o super-admin acessa como outro usuário */
export function ImpersonationBanner() {
  const { impersonation, stopImpersonation } = useAuth();
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!impersonation) return;
    const t = setInterval(() => setNow(Date.now()), 30_000);
    return () => clearInterval(t);
  }, [impersonation]);
  if (!impersonation) return null;
  const left = Math.max(0, Math.ceil((impersonation.expiresAt - now) / 60_000));
  return (
    <div role="status" className="flex flex-wrap items-center justify-between gap-2 px-4 py-2 text-sm font-medium" style={{ background: '#fde68a', color: '#451a03' }} data-testid="impersonation-banner">
      <span>Você está acessando como <strong>{impersonation.nome}</strong> ({impersonation.email}). Tudo o que fizer fica registrado na auditoria. Restam {left} min.</span>
      <Button size="sm" variant="secondary" onClick={() => { void stopImpersonation(); }}>Sair da personificação</Button>
    </div>
  );
}
